import Action, {GET, POST_FORM,POST , PUT} from "../common/Action";

export const getBooksAction = new Action('GET_BOOKS', POST, 'books/InvList');
export const getBooksEventAction = new Action('GET_BOOKS_EVENT', POST, 'books/list');
export const getBookCategoriesAction = new Action('GET_BOOK_CATEGORIES' , GET ,'Category') ;
export const getBookInfoAction = new Action('GET_BOOK_INFO' , GET , (params) => `Books/${params.id}`) ;
export const addBookAction = new Action('ADD_BOOK', POST, 'Books') ;
export const editBookAction = new Action('EDIT_BOOK', PUT, (params) => `Books/${params.id}`) ;

export const getBooks = (query) => getBooksAction.callApi(query);
export const getBooksEvent = (query) => getBooksEventAction.callApi(query);
export const getBookCategories = () => getBookCategoriesAction.callApi() ;
export const getBookInfo = (id) => getBookInfoAction.callApi(null ,{id : id} ) ;
export const addBook = (data) => addBookAction.callApi(data) ;
export const editBook = (id, data) => editBookAction.callApi(data, ({id})) ;